const configuredBaseUrl = import.meta.env.VITE_MARKETING_BASE_URL as string | undefined;

const supportedLanguages = new Set(['ca', 'de', 'en', 'es', 'fr', 'it']);

function getMarketingBaseUrl(): string {
  const configuredUrl = configuredBaseUrl?.trim().replace(/\/$/, '');
  if (configuredUrl) return configuredUrl;

  if (typeof window === 'undefined') return '';

  const url = new URL(window.location.origin);
  if (url.hostname === 'localhost' || url.hostname === '127.0.0.1' || url.hostname === '::1') {
    url.port = '3000';
  } else if (url.hostname.startsWith('app.')) {
    url.hostname = url.hostname.slice(4);
  }

  return url.origin;
}

export function getMarketingUrl(language: string | undefined, page: 'privacy' | 'terms'): string {
  const normalizedLanguage = language?.toLowerCase().split('-')[0] ?? 'en';
  const locale = supportedLanguages.has(normalizedLanguage) ? normalizedLanguage : 'en';
  const baseUrl = getMarketingBaseUrl();

  return `${baseUrl}/${locale}/${page}`;
}
